import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout, Button, DatePicker } from 'element-react';
import "./opinionsMailbox.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import img from "../../img/home/characteristic/img1.png";
import 'element-theme-default';

export default class opinionsMailbox extends PureComponent {
  constructor(props) {
    super(props);
    this.uploadRef = React.createRef();
    this.state = {
      userType: 1, //用户类型：1士兵，2干部，3优抚对象
 
      enlistmentTimeOut: '',
      retirementTimeOut: '',

      attachmentNameOut: '',
      attachmentPathOut: '',
      form: {
        // attachmentName:'',
        // attachmentPath:'',
        name: '',
        sex: '',
        age: '',
        communistStatus: '',
        nation: '',
        education: '',
        idNumber: '',
        permanentAddress: '',
        postalAddress: '',
        enlistmentTime: '',
        retirementTime: '',
        presentSituation: '',
        practiceType: '',

        registeredResidenceType: '',
        retiredSoldierType: '',
        soldiersResettlementMode: '',
        workSituation: '',

        rank: '',
        cadreResettlementMode: '',

        preferentialTreatmentObjectStatus: '',
        preferentialTreatmentObjectCategory: '',
        messageTitle: '',
        messageBody: '',
        businessCategory: '',
        email: '',
        contactNumber: '',
        veriCode: '',
      },

    };
  }

  componentDidMount() {
    const idVal = Request.GetUrlParam('id');//获取地址栏参数
    Http.get(Request.businessonsultingDetail(), { "id": idVal }, obj => {
      console.log('businessonsultingDetail---', obj)
      if (obj) {
        this.setState({
          form: obj.data
        })
      }
    });
  }



  render() {
    const { form, userType } = this.state;

    return (
      <div className="complaint-container">
        <fieldset disabled>
        <Form ref="form" model={form} labelWidth="80" className="demo-ruleForm">
          <Row gutter={8}>
            <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
              <span className="title">业务咨询详情</span>
            </Col>
            {/* <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
              <span className="SO_title2">欢迎您访问内蒙古自治区退役军人事务厅【业务咨询】栏目！业务咨询是用于接收公众对退役军人相关事务办理的网上咨询渠道，对于网友留言我们都会认真研究、汇总和整理，不定期在我厅网站上做问题答复。如果是反映个人诉求，请到【网上信访】栏目，我们会有专人负责为您解决和答复，在这里留言不作应答。</span>
            </Col>
            <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
              <span className="SO_title3">感谢您对内蒙古自治区退役军人事务厅工作的关注和支持！</span>
            </Col> */}
            <Col sm={{ span: 6 }}>
              <Form.Item label="姓名"  >
                <Input value={form.name} ></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="性别"  >
                <Input value={form.sexName} ></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="年龄"  >
                <Input value={form.age}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="是否党员"  >
                <Input value={form.communistStatus == 1 ? '是' : '否'}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="民族"  >
                <Input value={form.nation}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="学历"  >
                <Input value={form.educationName} ></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="身份证号"  >
                <Input value={form.idNumber} ></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="户籍地址"  >
                <Input value={form.permanentAddress} ></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="通讯地址"  >
                <Input value={form.postalAddress}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="电子邮箱"  >
                <Input value={form.email} ></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="手机号码"  >
                <Input value={form.contactNumber}></Input>
              </Form.Item>
            </Col>

            <Col sm={{ span: 6 }}>
              <Form.Item label="入伍时间"  >
                <Input value={form.enlistmentTime}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="退役时间"  >
                <Input value={form.retirementTime}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="现状"  >
                <Input value={form.presentSituationName}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="从业类型"  >
                <Input value={form.practiceTypeName}></Input>
              </Form.Item>
            </Col>

            {/* <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
              <span className="title">用户类型：</span>
              <Radio.Group>
                <Radio value={1}>士兵</Radio>
                <Radio value={2}>干部</Radio>
                <Radio value={3}>优抚对象</Radio>
              </Radio.Group>
            </Col> */}
            {userType == 1 ? <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
              <Col sm={{ span: 6 }}>
                <Form.Item label="户籍类型">
                  <Input value={form.registeredResidenceTypeName}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="退役兵类型" labelWidth="100">
                  <Input value={form.retiredSoldierTypeName}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="安置方式">
                  <Input value={form.soldiersResettlementModeName}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="工作情况">
                  <Input value={form.workSituationName}></Input>
                </Form.Item>
              </Col>
            </Col> : (userType == 2 ? <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
              <Col sm={{ span: 6 }}>
                <Form.Item label="职级">
                  <Input value={form.rankName}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="安置方式">
                  <Input value={form.cadreResettlementModeName}></Input>
                </Form.Item>
              </Col>
            </Col> : <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
              <Col sm={{ span: 7 }}>
                <Form.Item label="是否优抚对象" labelWidth="120">
                  <Input value={form.preferentialTreatmentObjectStatus == 1 ? '是' : '否'}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 7 }}>
                {form.preferentialTreatmentObjectStatus == "2" ? <Form.Item label="优抚对象类别" labelWidth="120">
                  <Input value={form.preferentialTreatmentObjectCategoryName}></Input>
                </Form.Item> : null}
              </Col>
            </Col>)}
            <Col sm={{ span: 24 }}>
              <Form.Item label="留言标题">
                <Input value={form.messageTitle}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }}>
              <Form.Item label="留言正文">
                <Input
                  type="textarea"
                  autosize={{ minRows: 10, maxRows: 20 }}
                  // rows={10}
                  resize='none'
                  value={form.messageBody}
                />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }}>
              <Form.Item label="业务类别">
                <Input value={form.businessCategoryName} />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }}>
                <Form.Item label="附件" props="category">
                  <a target="_blank" href={form.attachmentPath ? form.attachmentPath.replace("blob:", '') : ''}><img src={form.attachmentPath} alt="" width='200px' /></a>
                </Form.Item>
              </Col>
          </Row>

        </Form>
        </fieldset>
      </div >
    );
  }
}
